import { createAction } from '@reduxjs/toolkit';
import type { ComplianceData } from 'commons/modules/service/compliance';
import { createReportSlice } from './reportStore';

// Initial filter keys for Compliance report
const initialFilters = {
  alertType: '',
  institute: '',
  client: '',
  issuer: '',
  status: '',
};

// Custom action to toggle selection on a specific compliance item
export const selectedOperation = createAction<ComplianceData>(
  'operationCompliance/selectedOperation',
);

// Create generic slice instance for this report with custom extensions
const slice = createReportSlice<ComplianceData>(
  'operationCompliance',
  initialFilters,
  (builder) => {
    // Handle selectedOperation - toggle selected field on specific item
    builder.addCase(selectedOperation, (state, action) => {
      const { id } = action.payload;
      state.data = (state.data as ComplianceData[]).map((item) => {
        if (id === item.idCompliance) {
          return {
            ...item,
            selected: !item.selected,
          };
        }
        return item;
      });
    });
  },
);

// Reducer
export default slice.reducer;
